module.exports = __webpack_public_path__ + "img/childrens.d893cde8.png";